import { appInsights, reactPlugin, withAITracking } from "../../../appInsights";
import { FC, useCallback, useEffect, useRef } from "react";
import { useState } from "react";
import { cloneDeep, get, map } from "lodash";
//import { cloneDeep, sortBy, values } from "lodash";
import {
  Col,
  Card,
  Table,
  //Pagination,
  //Select,
  Row,
  //Input,
  Button,
  //Badge,
  Spin,
  DatePicker,
  Tooltip,
  Drawer,
  Input,
  Space,
  // InputRef,
  Modal,
} from "antd";
import "./adt-feed.scss";
//import { Option } from "antd/lib/mentions";
import { layerViews } from "@pages/members/constants";
//import DonutChart from "./donut-chart";
//import LineChart from "./line-chart";
import memberDetailsService from "@services/memberDetails.service";
import { useNavigate } from "react-router-dom";
import membersService from "@services/members.service";
import { dateFormatConfig, HOSPITAL_LIST_AND_CM_USER_ACCESS_LIST, HOSPITAL_LIST_AND_CM_USER_OPENED_FROM, routeMap } from "@utils/constants";
import moment from "moment";
import * as XLSX from "xlsx";
import TableConfig from "@components/tableConfigDrawer";
// import {  HUMAN_READABLE_DATETIME } from "@pages/utils/utils";
import { formatDisplayDate, formatDownloadFileNameDate, getClientName } from "@utils/helpers";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import HospitalMapping from "@components/hospitalMapping/hospitalMapping";

import { useGlobalInformationStore } from "../../../stores/global_informationStore";
import { useHospitalMappingStore } from "../../../stores/useHospitalMappingStore";
import { useConfigStore } from "@stores/useConfigStore";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import { TableLocale } from "@components/noDataFound";

const { RangePicker } = DatePicker;

const ADTFeeds: FC<any> = () => {
  //Config State
  const config = useConfigStore((state) => state.config);
  const clientName = getClientName();

  // selecting facility for hospital list and cm
  const setSelectedHospitalListFacility = useGlobalInformationStore((state) => state.setSelectedHospitalListFacility);
  const selectedHospitalListFacility = useGlobalInformationStore((state) => state.selectedHospitalListFacility);

  //Modal for Hospital List and CM
  const setIsBackButtonDisplay = useHospitalMappingStore((state) => state.setIsBackButtonDisplay);
  const setShowHospitalistsModal = useHospitalMappingStore((state) => state.setShowHospitalistsModal);
  const showHospitalistsModal = useHospitalMappingStore((state) => state.showHospitalistsModal);
  const setAvailableFacilityOfCurrentMember = useHospitalMappingStore((state) => state.setAvailableFacilityOfCurrentMember);
  const setHospitalMappingEditModeOpenedFrom = useHospitalMappingStore((state) => state.setHospitalMappingEditModeOpenedFrom);

  // const [selectFacility, setSelectFacility] = useState<any>("");

  //const appliedFilters = true;
  const [drawerViewtype] = useState(layerViews[1]);
  const [isOpenDrawer, toggleDrawerHandler] = useState(false);
  const [loadingForEncounter, setADTFlag] = useState(false);
  const [adtFeedsData, setADTFeedsData] = useState<any>([]);
  //const [copyAllMemberData, setCopyAllMemberData] = useState<any[]>([]);
  const [dateStartFilter, setDateStartFilter] = useState<string>("");
  const [dateEndFilter, setDateEndFilter] = useState<string>("");
  const [columnListdata, setColumnListData] = useState<any>([]);

  const [tableConfigData, setTableConfigData] = useState<Array<any>>();
  const [tempTableConfig, tempTableConfigHandler] = useState<Array<any>>();
  const [patientId, setPatientId] = useState<number>();
  const _patientName = useRef({});
  const navigate = useNavigate();
  const patientData = useRef<any>({});
  const [headingLoader, setHeadingLoader] = useState(false);

  //Modal for Hospital List and CM
  // const [showHospitalistsModal, setShowHospitalistsModal] = useState(false);

  const columnsData = useRef<any>(null);
  const adtFeedsDataForTempUse = useRef<any>(null);
  // const columnSearchInfo = useRef<any>({});
  const [columnSearchInfo, setColumnSearchInfo] = useState({});

  const cMember = membersService?.getCurrentMember;
  const pId = parseInt(cMember?.patient_id);

  useEffect(() => {
    console.log("ADTFeeds.useEffect1");

    const getAdtFeedsData = (id: number, startDate: string, endDate: string) => {
      console.log("GetGenericDrugPopOver.getAdtFeedsData");
      setADTFlag(true);
      memberDetailsService.getAdtFeeds(id, startDate, endDate).subscribe({
        next: (v) => {
          setADTFlag(false);

          setADTFeedsData(v?.data?.data?.result);
          adtFeedsDataForTempUse.current = v?.data?.data?.result;
          let facilityNames: string[] = [];
          v?.data?.data?.result.forEach((dataItem: any) => {
            if (!facilityNames.includes(dataItem.hosp_facility_name.toLocaleLowerCase())) {
              facilityNames.push(dataItem.hosp_facility_name.toLocaleLowerCase());
            }
          });

          setAvailableFacilityOfCurrentMember(facilityNames);
          facilityNames = [];
          //setCopyAllMemberData(v?.data?.data?.result);
        },
        error: (e) => {
          setADTFlag(false);
        },
      });
    };

    if (cMember && cMember?.patient_id) {
      _patientName.current = cMember.patient_name;
      setPatientId(pId);
      getAdtFeedsData(pId, dateStartFilter, dateEndFilter);
    } else navigate(routeMap["members"]);
  }, [dateStartFilter, dateEndFilter, navigate, setAvailableFacilityOfCurrentMember, cMember?.patient_id, pId]);

  const handleSearch = useCallback(
    (dataIndex: any) => {
      const text = get(columnSearchInfo, [dataIndex], "");
      const tempADTDeedsData: [] = cloneDeep(adtFeedsDataForTempUse.current);
      const td = tempADTDeedsData.filter((item: any) => {
        return item[dataIndex]?.toString().toLowerCase().includes(text.toString().toLowerCase());
      });
      setADTFeedsData(td);
    },
    [columnSearchInfo]
  );

  const highlighterColorCoded = useCallback(
    (text: any, textTosearch: string, underLineText: boolean, data: any) => {
      const onRowClick = () => {
        if (underLineText) {
          setShowHospitalistsModal(true);
          setHospitalMappingEditModeOpenedFrom(HOSPITAL_LIST_AND_CM_USER_OPENED_FROM.memberDetailADT);
          setSelectedHospitalListFacility(text);
        }
      };

      return (
        <span
          onClick={() => {
            onRowClick();
          }}
          style={{ justifyContent: "center", textDecoration: underLineText ? "underline" : "none", color: underLineText ? "#0072E3" : "#7A869A", cursor: underLineText ? "pointer" : "" }}
        >
          <Tooltip placement="topLeft" title={text ? text.toString() : ""}>
            <Highlighter highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }} searchWords={[textTosearch]} autoEscape textToHighlight={text ? `${text.toString()}` : ""} />
          </Tooltip>
        </span>
      );
    },
    [setHospitalMappingEditModeOpenedFrom, setSelectedHospitalListFacility, setShowHospitalistsModal]
  );

  const setColData = useCallback(
    (colData: any) => {
      const tcf = cloneDeep(colData.filter((col: any) => col.tableHeaderName))?.map((item: any) => {
        let filteredItem = colData.filter((cd: any) => cd.key === item.dataIndex);

        let newItem = { ...item };
        if (filteredItem.length > 0) {
          newItem.isSelected = filteredItem[0].isSelected;
          // newItem.required = filteredItem[0].required;
          newItem.sequence = filteredItem[0].order;
          newItem.label = filteredItem[0].displayName;
          newItem.title = filteredItem[0].tableHeaderName;

          newItem.sorter = (a: any, b: any) => {
            return a[newItem.dataIndex] && b[newItem.dataIndex] ? a[newItem.dataIndex].localeCompare(b[newItem.dataIndex]) : 0;
          };
        } else {
          newItem.isSelected = true;
          // newItem.required = true;
          newItem.isDraggable = true;
        }

        if (newItem.dataIndex === "event_datetime") {
          newItem.className = "add-feed-long-column";
        }
        newItem.width = 150;
        newItem.ellipsis = {
          showTitle: false,
        };
        newItem.isSearchDisplay = false;
        newItem.filterIcon = (filtered: any) => {
          return (
            <SearchOutlined
              style={{
                color: get(columnSearchInfo, newItem.dataIndex, "") !== "" ? "#EF6D2A" : undefined,
              }}
            />
          );
        };
        newItem.filterDropdown = ({ confirm }: any) => {
          return (
            <div style={{ padding: "10px" }}>
              <Input
                ref={inputref}
                value={get(columnSearchInfo, newItem.dataIndex, "")}
                style={{ marginBottom: 8, display: "block" }}
                onChange={(e) => {
                  // Workaround to store input values as useState is not working.
                  setColumnSearchInfo({
                    ...columnSearchInfo,
                    [newItem.dataIndex]: e.target.value,
                  });
                  // Workaround to update the UI.
                  setColData(columnsData.current);
                }}
                // onKeyPress={(e: any) => {
                //   if (e.key === "Enter") {
                //     e.preventDefault();
                //     for (const objItem in columnSearchInfo.current) {
                //       columnSearchInfo.current = { [objItem]: "" };
                //     }
                //     columnSearchInfo.current = { [newItem.dataIndex]: inputText };
                //     setColData(columnsData.current);
                //     handleSearch(newItem.dataIndex);
                //     confirm({ closeDropdown: true });
                //   }
                // }}
                onPressEnter={(e: any): any => {
                  setColData(columnsData.current);
                  handleSearch(newItem.dataIndex);
                  confirm({ closeDropdown: true });
                  e.stopPropagation();
                }}
              />
              <Space>
                <Button
                  type="primary"
                  icon={<SearchOutlined />}
                  size="small"
                  style={{ width: 90 }}
                  onClick={(e: any) => {
                    // for (const objItem in columnSearchInfo) {
                    //   columnSearchInfo.current = { [objItem]: "" };
                    // }

                    // columnSearchInfo.current = { [newItem.dataIndex]: get(columnSearchInfo, newItem.dataIndex, "") };
                    setColumnSearchInfo({ ...columnSearchInfo, [newItem.dataIndex]: get(columnSearchInfo, newItem.dataIndex, "") });
                    setColData(columnsData.current);
                    handleSearch(newItem.dataIndex);
                    confirm({ closeDropdown: true });
                  }}
                >
                  Search
                </Button>

                <Button
                  onClick={(e) => {
                    setColumnSearchInfo({ ...columnSearchInfo, [newItem.dataIndex]: "" });
                    // columnSearchInfo.current = { [newItem.dataIndex]: "" };
                    setADTFeedsData(adtFeedsDataForTempUse.current);
                    setColData(columnsData.current);
                    confirm({ closeDropdown: true });
                  }}
                  size="small"
                  style={{ width: 90 }}
                >
                  Reset
                </Button>
              </Space>
            </div>
          );
        };
        newItem.render = (text: any) => {
          let formatedText = text;
          let underLineText = false;
          if (newItem?.dataIndex === "event_datetime" || newItem?.dataIndex === "admit_timestamp" || newItem?.dataIndex === "discharge_timestamp") {
            formatedText = text ? formatDisplayDate(text, "reminderDateActualFormat", "defaultDateFormatWithTime") : "";
          }

          // Hospital List and CM
          if (newItem?.dataIndex === "hosp_facility_name" && getClientName() !== "Millennium") {
            underLineText = true;
          }

          return highlighterColorCoded(formatedText, get(columnSearchInfo, newItem.dataIndex, ""), underLineText, newItem);
        };
        newItem.onFilter = (value: any, record: any) => (record[newItem.dataIndex] ? record[newItem.dataIndex].toString().toLowerCase().includes(value.toLowerCase()) : "");
        newItem.onFilterDropdownOpenChange = (visible: any) => {
          if (visible) {
            setTimeout(() => inputref.current?.select(), 100);
          }
        };
        return newItem;
      });

      // console.log("What is in tcf",tcf );
      columnsData.current = tcf;
      setTableConfigData(tcf);
      tableConfigCallback(tcf);
    },
    [columnSearchInfo, handleSearch, highlighterColorCoded]
  );

  const getCloumnList = useCallback(() => {
    memberDetailsService.getColumnsList().subscribe({
      next: (v) => {
        const colData = v?.data?.data?.columns;
        setColumnListData(colData);
        setColData(colData);
      },
      error: (e) => {
        setColumnListData([]);
      },
    });
  }, [setColData]);

  // Subham will look into this
  useEffect(() => {
    console.log("ADTFeeds.useEffect2");
    getCloumnList();
  }, [getCloumnList]);

  useEffect(() => {
    console.log("ADTFeeds.useEffect3");
    appInsights.trackPageView({ name: "ADT Feeds" });
  }, []);

  const toggleDrawer = () => {
    toggleDrawerHandler(!isOpenDrawer);
  };
  /*const toggleDrawerViewType = (type: any) => {
    if (drawerViewtype !== type) {
      setDrawerViewtype(type);
      toggleDrawer();
    }
  };*/

  useEffect(() => {
    console.log("ADTFeeds.useEffect4");
    if (columnListdata.length > 0 && adtFeedsData?.length > 0) {
      columnListdata.forEach((col: any) => {
        if (col.order === 9999) {
          patientData.current[col.dataIndex] = { value: adtFeedsData[0][col.dataIndex], label: columnListdata.find((column: any) => column.dataIndex === col.dataIndex).displayName };
        }
      });
      setHeadingLoader(true);
    }
  }, [columnListdata, adtFeedsData]);

  const inputref = useRef<any>(null);

  const SearchFilter = (item: any) => {
    return {
      ...item,
      filterDropdown: ({ confirm }: any) => {
        return (
          <div style={{ padding: "10px" }}>
            <Input
              ref={inputref}
              value={get(columnSearchInfo, item.dataIndex, "")}
              style={{ marginBottom: 8, display: "block" }}
              onChange={(e) => {
                // Workaround to store input values as useState is not working.
                setColumnSearchInfo({
                  ...columnSearchInfo,
                  [item.dataIndex]: e.target.value,
                });
                // Workaround to update the UI.
                setColData(columnsData.current);
              }}
              // onKeyPress={(e: any) => {
              //   if (e.key === "Enter") {
              //     e.preventDefault();
              //     for (const objItem in columnSearchInfo.current) {
              //       columnSearchInfo.current = { [objItem]: "" };
              //     }
              //     columnSearchInfo.current = { [newItem.dataIndex]: inputText };
              //     setColData(columnsData.current);
              //     handleSearch(newItem.dataIndex);
              //     confirm({ closeDropdown: true });
              //   }
              // }}
              onPressEnter={(e: any): any => {
                setColData(columnsData.current);
                handleSearch(item.dataIndex);
                confirm({ closeDropdown: true });
                e.stopPropagation();
              }}
            />
            <Space>
              <Button
                type="primary"
                icon={<SearchOutlined />}
                size="small"
                style={{ width: 90 }}
                onClick={(e: any) => {
                  // for (const objItem in columnSearchInfo) {
                  //   columnSearchInfo.current = { [objItem]: "" };
                  // }

                  // columnSearchInfo.current = { [newItem.dataIndex]: get(columnSearchInfo, newItem.dataIndex, "") };
                  setColumnSearchInfo({ ...columnSearchInfo, [item.dataIndex]: get(columnSearchInfo, item.dataIndex, "") });
                  setColData(columnsData.current);
                  handleSearch(item.dataIndex);
                  confirm({ closeDropdown: true });
                }}
              >
                Search
              </Button>

              <Button
                onClick={(e) => {
                  setColumnSearchInfo({ ...columnSearchInfo, [item.dataIndex]: "" });
                  // columnSearchInfo.current = { [newItem.dataIndex]: "" };
                  setADTFeedsData(adtFeedsDataForTempUse.current);
                  setColData(columnsData.current);
                  confirm({ closeDropdown: true });
                }}
                size="small"
                style={{ width: 90 }}
              >
                Reset
              </Button>
            </Space>
          </div>
        );
      },
      filterIcon: (filtered: any) => {
        return (
          <SearchOutlined
            style={{
              color: get(columnSearchInfo, item.dataIndex, "") !== "" ? "#EF6D2A" : undefined,
            }}
          />
        );
      },
      render: (text: any) => {
        let formatedText = text;
        let underLineText = false;
        if (item?.dataIndex === "event_datetime" || item?.dataIndex === "admit_timestamp" || item?.dataIndex === "discharge_timestamp") {
          formatedText = text ? formatDisplayDate(text, "reminderDateActualFormat", "defaultDateFormatWithTime") : "";
        }
        // Hospital List and CM
        if (item?.dataIndex === "hosp_facility_name" && getClientName() !== "Millennium") {
          underLineText = true;
        }
        return highlighterColorCoded(formatedText, get(columnSearchInfo, item.dataIndex, ""), underLineText, item);
      },
      onFilter: (value: any, record: any) => (record[item.dataIndex] ? record[item.dataIndex].toString().toLowerCase().includes(value.toLowerCase()) : ""),
      onFilterDropdownOpenChange: (visible: any) => {
        if (visible) {
          setTimeout(() => inputref.current?.select(), 100);
        }
      },
    };
  };

  const _xyz: Array<{}> = map(cloneDeep(tableConfigData), (dataInfo: any) => {
    return SearchFilter(dataInfo);
  });

  /*const handleSearch = (e: any) => {
    if (e?.target?.value && e?.target?.value !== "") {
      let ccMembers = [...copyAllMemberData];
      let d = ccMembers.filter(
        (row) =>
          Object.values(row).find((value: any) => {
            let val = isNaN(value)
              ? value.toLowerCase()
              : ("" + value).toLowerCase();
            return val?.indexOf((e?.target?.value).toLowerCase()) > -1;
          }) !== undefined
      );
      setADTFeedsData(d);
    } else setADTFeedsData(copyAllMemberData);
  };*/

  const downloadLite = () => {
    let ccData = [...adtFeedsData];
    let data = [];
    // if(columnsType === "lite"){
    //     data = ccData.map((row: any) => {
    //         const obj : any = {};
    //         columns.filter((col:any) => col.isSelected && col.dataIndex !== "action").forEach((col:any) => obj[col.dataIndex] = row[col.dataIndex]);
    //         return obj;
    //     });
    // }
    // else {
    if (ccData?.length > 0) {
      data = ccData.map((item: any) => {
        // delete item.notes;
        // delete item.reminders;
        // delete item.alerts;
        // delete item.profilePicture;
        item.hosp_visit_number = item.hosp_visit_number !== null ? (isNaN(Number(item.hosp_visit_number)) ? item.hosp_visit_number : "'" + item.hosp_visit_number) : item.hosp_visit_number;
        item.hosp_episode_id = item.hosp_episode_id !== null ? (isNaN(Number(item.hosp_episode_id)) ? item.hosp_episode_id : "'" + item.hosp_episode_id) : item.hosp_episode_id;
        delete item.patientID;
        delete item.patientName;
        delete item.clientID;
        return item;
      });

      let headersCreatedForFileDownload: any = {};
      let customizedData: any[] = [];
      const dataHeaderSelected = Object.keys(data[0]);

      tableConfigData?.forEach((element) => {
        headersCreatedForFileDownload[element.dataIndex] = element.tableHeaderName;
      });

      customizedData = data.map((entries) => {
        let customizedEntries: any = {};
        for (let i = 0; i < dataHeaderSelected.length; i++) {
          if (headersCreatedForFileDownload[dataHeaderSelected[i]]) customizedEntries[headersCreatedForFileDownload[dataHeaderSelected[i]]] = entries[dataHeaderSelected[i]];
        }
        return customizedEntries;
      });

      // }

      const fileName = `${_patientName.current} - adtFeeds_Detail_${formatDownloadFileNameDate(new Date())}.csv`;
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(customizedData);
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "ADT Feeds");
      XLSX.writeFile(wb, fileName);
    }
  };

  const handleDateChangeFilter = (range: any) => {
    const startDate = range && range.length > 0 ? range[0].format("YYYY-MM-DD") : "";
    const endDate = range && range.length > 0 ? range[1].format("YYYY-MM-DD") : "";
    setDateStartFilter(startDate);
    setDateEndFilter(endDate);
  };

  const resetDefaultTableConfig = ({ action = "default" }) => {
    if (action === "default") {
      let columnData = cloneDeep(tempTableConfig);
      columnData = columnData?.map((col: any) => {
        if (col.isDraggable) {
          if (col.isDefault === "Y") {
            col.sequence = col.defaultDisplayOrder;
            col.isSelected = true;
            col.draggable = true;
          } else {
            col.sequence = 0;
            col.isSelected = false;
            col.draggable = false;
          }
        } else {
          col.sequence = col.order;
          col.isSelected = true;
          col.draggable = true;
        }
        return col;
      });
      tempTableConfigHandler(columnData);
    } else {
      tempTableConfigHandler(tableConfigData);
    }
  };

  const tableConfigCallback = (data: any) => {
    tempTableConfigHandler(data);
  };

  const onCloseConfigDrawer = () => {
    toggleDrawer();
    resetDefaultTableConfig({ action: "revert" });
    // tempFiltersDataHandler(filtersData);
  };

  //Main Drawer View
  const drawerView = () => {
    return drawerViewtype.key === layerViews[0].key ? <> </> : <TableConfig configUpdatehandler={tableConfigCallback} tableConfigData={cloneDeep(tempTableConfig)} />;
  };

  /**
   * Function to update table configuration
   * This function uses
   * - tempTableConfig and columnListdata
   *
   */
  const updateTableConfig = () => {
    const columns: any = [];
    tempTableConfig?.forEach((col: any) => {
      const arr = columnListdata.filter((cld: any) => col.dataIndex === cld.key);
      if (arr && arr.length > 0 && col.isSelected) columns.push({ column_id: arr[0].column_id, order: col.sequence });
    });

    memberDetailsService.updateAdtColumns(columns).subscribe({
      next: (v) => {
        // clear all col search text
        // for (const objItem in columnSearchInfo) {
        //   columnSearchInfo.current[objItem] = "";
        // }
        getCloumnList();
        setTableConfigData(tempTableConfig);
      },
      error: (e) => {},
    });

    toggleDrawer();
  };

  // Drawer Footer
  const drawerFooter = () => {
    return (
      <div style={{ textAlign: "right" }} className="cancel-button">
        <Button type="text" size="large" onClick={onCloseConfigDrawer}>
          {" "}
          Cancel{" "}
        </Button>

        {drawerViewtype.key === layerViews[0].key ? (
          <Button type="primary" onClick={() => {}} className="apply-filter" style={{ height: "40px" }}>
            Apply Filter
          </Button>
        ) : (
          <Button type="primary" onClick={updateTableConfig} style={{ height: "40px" }}>
            Update Table
          </Button>
        )}
      </div>
    );
  };

  // For rendering drawer Header
  const drawerHeader = () => {
    return drawerViewtype.key === layerViews[0].key ? (
      <Button type="link" onClick={() => {}} className="clr-e100" style={{ fontWeight: "normal" }}>
        Clear All
      </Button>
    ) : (
      <>
        <Button type="link" className="clr-blueLink" style={{ fontWeight: "normal" }} onClick={() => resetDefaultTableConfig({})}>
          Reset to default View
        </Button>
      </>
    );
  };

  return (
    <Spin spinning={loadingForEncounter} indicator={<HealthemSpinner size={70} />}>
      <div>
        <Card>
          <Row style={{ alignItems: "center", justifyContent: "end" }}>
            <Col style={{ alignItems: "center" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {clientName !== "Millennium" && (
                  <Button
                    type="primary"
                    style={{ height: "40px" }}
                    onClick={() => {
                      setShowHospitalistsModal(true);
                      setSelectedHospitalListFacility("");
                    }}
                  >
                    CM Contact Matrix
                  </Button>
                )}
                <Tooltip title="Download XLS">
                  <i
                    className="btn-icon icon-download clr-n125"
                    style={{ width: "20px", height: "20px" }}
                    onClick={() => {
                      downloadLite();
                    }}
                  />
                </Tooltip>

                <i style={{ marginRight: 8 }} className="btn-icon icon-settings clr-n125" onClick={() => toggleDrawer()} />

                <div className="reminderDatePickerKeyInsight">
                  <div className="reminderDateLabel">
                    <span className="icon-calendar f18" />
                  </div>
                  <RangePicker
                    picker="date"
                    format={dateFormatConfig.get(getClientName())["defaultDateFormat"]}
                    allowClear={true}
                    dropdownClassName="reminder-picker"
                    ranges={{
                      "More Filters:": [null, null],
                      "Next 7 Days": [moment(), moment().add(7, "days")],
                      "Last 7 Days": [moment().subtract(7, "days"), moment()],
                    }}
                    onChange={(range) => {
                      handleDateChangeFilter(range);
                    }}
                  />
                </div>
              </div>
            </Col>
          </Row>
        </Card>
        <Card style={{ marginTop: 7 }} className={"adt-container"}>
          <Row>
            <Col span={24}>
              {headingLoader && adtFeedsData?.length > 0 ? (
                <>
                  <span className="member-key">{get(patientData, "current.patient_name.label", "Check Column Config")}</span>
                  <span className="member-value">{get(patientData, "current.patient_name.value", "NA")}</span> |
                  <span className="member-key">{get(patientData, "current.client_id_1.label", "Check Column Config")}</span>
                  <span className="member-value">{get(patientData, "current.client_id_1.value", "NA")}</span> |
                  <span className="member-key">{get(patientData, "current.member_dob.label", "Check Column Config")}</span>
                  <span className="member-value">{get(patientData, "current.member_dob.value", "NA")}</span> |
                  <span className="member-key">{get(patientData, "current.pcp_name.label", "Check Column Config")}</span>
                  <span className="member-value">{get(patientData, "current.pcp_name.value", "NA")}</span>
                </>
              ) : null}
            </Col>
          </Row>

          <Row style={{ marginTop: 10 }}>
            <Col span={24}>
              <Table
                bordered={true}
                key={patientId}
                // pagination={{ position: [ 'bottomRight'] }}
                pagination={{
                  defaultPageSize: 10,
                  showSizeChanger: true,
                  pageSizeOptions: ["5", "10", "15", "20", "25", "30"],
                }}
                // loading={loading}
                columns={_xyz
                  ?.sort((a: any, b: any) => a.sequence - b.sequence)
                  .filter((item: any) => {
                    return item.isSelected;
                  })
                  .map((columnType: any) => {
                    // if (columnType?.dataIndex === "event_datetime" || columnType?.dataIndex === "admit_timestamp" || columnType?.dataIndex === "discharge_timestamp") {
                    //   return {
                    //     ...columnType,
                    //     render: ({date, record, setSelectedKeys, selectedKeys, clearFilters}: any) => {
                    //       console.log("FINAL**", selectedKeys, record);

                    //       return date ? formatDisplayDate(date , "reminderDateActualFormat" , "defaultDateFormatWithTime") : "";
                    //       // return highlighterColorCoded(formatDisplayDate(date , "reminderDateActualFormat" , "defaultDateFormatWithTime"), )
                    //     },
                    //   };
                    // } else {
                    //   return columnType;
                    // }
                    return columnType;
                  })}
                dataSource={adtFeedsData}
                scroll={{ x: 1200 }}
                locale={TableLocale}
              />
            </Col>
          </Row>
          <Modal
            width={"70%"}
            visible={showHospitalistsModal}
            onCancel={() => {
              setShowHospitalistsModal(false);
              // setSelectedHospitalListFacility("");
              setHospitalMappingEditModeOpenedFrom(HOSPITAL_LIST_AND_CM_USER_OPENED_FROM.None);
            }}
            cancelButtonProps={{ hidden: true }}
            okButtonProps={{ hidden: true }}
            className={"adt-container__hospitalList-modal"}
          >
            <HospitalMapping currentMode="read" facility={selectedHospitalListFacility} />
            <div className="cm-mapping-modal">
              {HOSPITAL_LIST_AND_CM_USER_ACCESS_LIST.includes(config.role) ? (
                <Button
                  type="primary"
                  onClick={() => {
                    setIsBackButtonDisplay(true);
                    setHospitalMappingEditModeOpenedFrom(HOSPITAL_LIST_AND_CM_USER_OPENED_FROM.memberDetailADT);
                    navigate(routeMap.dashboard);
                  }}
                >
                  Edit Fields
                </Button>
              ) : null}
            </div>
          </Modal>
        </Card>
      </div>
      <Drawer
        destroyOnClose={true}
        title={drawerViewtype.label}
        placement="right"
        closable={false}
        onClose={onCloseConfigDrawer}
        visible={isOpenDrawer}
        key="right"
        width={drawerViewtype.width}
        bodyStyle={{ padding: drawerViewtype.padding }}
        className={`membersListingDrawer ${drawerViewtype.className}`}
        footer={drawerFooter()}
        extra={drawerHeader()}
      >
        {drawerView()}
      </Drawer>
    </Spin>
  );
};

export default withAITracking(reactPlugin, ADTFeeds);
